import { useQuery } from '@apollo/client';
import { GET_PUBLISHED_POST } from '@core/ui/graphql/Profile.query';
import React, { useState } from 'react';
import Box from 'reusecore/src/elements/Box';
import ListGrid from 'reusecore/src/elements/ListGrid';
import CardLoader from '../../components/Loader/CardLoader';
import PostCard from '../../components/PostCard';
import { CURRENCY } from '../../Config';

const UserPost = props => {
  const { uid } = props;

  const [loadingMore, toggleLoading] = useState(false);
  const [page, paginate] = useState(1);

  const QUERY_VARIABLES = {
    USERNAME: uid,
    LIMIT: 8,
  };

  const { data, loading, error, fetchMore, refetch, networkStatus } = useQuery(
    GET_PUBLISHED_POST,
    {
      variables: QUERY_VARIABLES,
      ssr: false,
    }
  );

  let { author: { id, posts: { data: posts = [], total = 0 } = {} } = {} } =
    data || {};

  if (posts === null) {
    posts = [];
  }

  const postsCount = posts.length;

  const renderRelatedPost = item => {
    const {
      additionalType = '',
      category = '',
      id: itemId = '',
      media: images = [],
      photos = [],
      price = null,
      sid,
      title = '',
      town = '',
      updatedAt = '',
    } = item;

    const checkPrice = price > 0 ? price : null;

    return (
      <PostCard
        currency={CURRENCY}
        additionalType={additionalType}
        title={title}
        price={checkPrice}
        id={itemId}
        sid={sid}
        category={category}
        town={town}
        createdAt={updatedAt}
        imageSrc={images}
        photos={photos}
        hn="h3"
      />
    );
  };

  return (
    <>
      <h3>Nos dernières annonces</h3>
      <Box mt={30} width={1}>
        <ListGrid
          data={posts}
          totalPost={total}
          postCount={postsCount}
          columnWidth={[1, 1 / 2, 1 / 3, 1 / 4]}
          component={renderRelatedPost}
          loading={loading ? loading : loadingMore}
          placeholder={<CardLoader />}
          limit={QUERY_VARIABLES.LIMIT}
          handleLoadMore={() => {
            toggleLoading(true);
            paginate(page + 1);
            fetchMore({
              variables: {
                page: page + 1,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult.author.posts) {
                  toggleLoading(false);
                  return prev;
                }
                if (postsCount && total) {
                  if (postsCount <= total) {
                    toggleLoading(false);

                    const {
                      author: {
                        posts: { data: prevPosts = [] },
                      },
                    } = prev;
                    const {
                      author: {
                        posts: { data: newPosts = [] },
                      },
                    } = fetchMoreResult;

                    return {
                      author: {
                        id,
                        posts: {
                          data: [...prevPosts, ...newPosts],
                          total,
                        },
                      },
                    };
                  }
                }
              },
            });
          }}
        />
      </Box>
    </>
  );
};

export default UserPost;
